export const GROUP_PLAN_SUPPORT_ARTICLE =
  'https://help.smarty.co.uk/en/collections/1974243-group-plans'
